/**
 * Sana va vaqt — QO'LDA yig'iladi.
 *
 * NEGA `toLocaleDateString('uz-UZ')` EMAS: u muhitga qarab boshqacha
 * chizadi — Chrome `2026-09-17` beradigan joyda Node `17/09/2026`
 * beradi. `day`/`month`/`year` sozlamalari esa maydonlarni
 * o'zgartiradi, TARTIBNI emas. Admin panelda bu tuzoq allaqachon
 * hujjatlashtirilgan (`admin-panel/src/lib/format.ts`); Mini App'da
 * shunga o'xshash yordamchi yo'q edi va sana `toLocaleString()` bilan
 * chizilardi.
 */

const pad2 = (n: number) => String(n).padStart(2, '0');

/** `17.09.2026` */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}.${d.getFullYear()}`;
}

/**
 * `14 150 000` — soʻm summasi.
 *
 * `Intl.NumberFormat('uz-UZ')` Chrome'da vergul qoʻyadi (`14,150,000`),
 * bu esa oʻzbek meʼyoriga toʻgʻri kelmaydi — razryadlar boʻsh joy bilan
 * ajratiladi. Ajratgich UZILMAYDIGAN boʻsh joy (U+00A0): aks holda tor
 * ekranda summa qator oxirida ikkiga boʻlinib ketadi.
 *
 * Admin paneldagi `format.ts` bilan bir xil — ikkalasi bir xil raqamni
 * bir xil chizishi kerak.
 */
export function formatMoney(value: number | string | null | undefined): string {
  const n = Number(value) || 0;
  return Math.trunc(Math.abs(n))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    .replace(/^/, n < 0 ? '−' : '');
}

/** `17.09.2026, 14:05` */
export function formatDateTime(
  value: string | Date | null | undefined,
): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return `${formatDate(d)}, ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
